import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { setCurrentRoute } from './routeStore';

export function RouteListener(): JSX.Element | null {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace(/^\//, '');
    setCurrentRoute(path || 'login');
  }, [location]);

  return null;
}
